import * as tslib_1 from "tslib";
import { Type } from 'class-transformer';
import * as moment from 'moment-timezone';
import { KeyValueResultDto } from '../../../../../_models/key-value-result-dto';
import { DimensionSelectorResultDto } from '../../common/dimensions/dimension-selector-result-dto';
import { GLAccountSelectorResultDto } from '../../common/gl-account/glaccount-selector-result-dto';
import { ARPaymentRawDto } from './ar-payment-raw-dto';
const ɵ0 = () => ARPaymentRawDto, ɵ1 = () => KeyValueResultDto, ɵ2 = () => KeyValueResultDto, ɵ3 = () => Date, ɵ4 = () => DimensionSelectorResultDto, ɵ5 = () => GLAccountSelectorResultDto;
export class ARPaymentEditorResultDto {
    get minPostDate() {
        return !!this.closedBookPeriod ? moment(this.closedBookPeriod).add(1, 'day').toDate() : null;
    }
}
tslib_1.__decorate([
    Type(ɵ0),
    tslib_1.__metadata("design:type", ARPaymentRawDto)
], ARPaymentEditorResultDto.prototype, "paymentInfo", void 0);
tslib_1.__decorate([
    Type(ɵ1),
    tslib_1.__metadata("design:type", Array)
], ARPaymentEditorResultDto.prototype, "paymentTypes", void 0);
tslib_1.__decorate([
    Type(ɵ2),
    tslib_1.__metadata("design:type", Array)
], ARPaymentEditorResultDto.prototype, "subLedgers", void 0);
tslib_1.__decorate([
    Type(ɵ3),
    tslib_1.__metadata("design:type", Date)
], ARPaymentEditorResultDto.prototype, "closedBookPeriod", void 0);
tslib_1.__decorate([
    Type(ɵ4),
    tslib_1.__metadata("design:type", Array)
], ARPaymentEditorResultDto.prototype, "dimensions", void 0);
tslib_1.__decorate([
    Type(ɵ5),
    tslib_1.__metadata("design:type", Array)
], ARPaymentEditorResultDto.prototype, "glAccounts", void 0);
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5 };
